"use client";

import { useEffect, useState } from "react";
import { deferThirdPartyScript } from "@/helpers/deferThirdPartyScript";

/**
 * Gates third-party mounts behind a fixed 3s delay, then an idle slot so
 * the load never lands inside a user interaction (INP-safe).
 *
 * @param delayMs Optional stagger after the gate opens. Use 0 for
 * lead-critical (GTM, WebEngage, VWO, modals). Use >0 only for non-lead.
 */
export function useShouldLoadThirdPartyScripts(delayMs = 0): boolean {
  const [shouldLoadScripts, setShouldLoadScripts] = useState(false);

  useEffect(() => {
    return deferThirdPartyScript(
      () => {
        setShouldLoadScripts(true);
      },
      { delayMs },
    );
  }, [delayMs]);

  return shouldLoadScripts;
}
